import React from 'react';
import { Link } from 'react-router-dom';

import styles from '../styles/Logo.module.css'

const Logo = ({ to, position }) => {
  const [isLoaded, setIsLoaded] = React.useState(false);

  if (!to) to = '/';

  const logoStyles = `${styles.logoContainer} ${position === 'relative' ? styles.relativeLogo : ''}`;

  return (
    <Link className={logoStyles} to={to}>
        {!isLoaded && (<div className={styles.loadingPlaceholder} />)}
        <img src='/img/logo/mainlogo-1080.png' alt='ЛК СОАУ Альянс' className={styles.logo} style={{display: isLoaded ? 'block' : 'none'}} onLoad={() => {setIsLoaded(true)}} />
    </Link>
  )
}

export default Logo;